import { render, staticRenderFns } from "./SMSIntegrationView.vue?vue&type=template&id=1a85f802"
import script from "./SMSIntegrationView.vue?vue&type=script&lang=js"
export * from "./SMSIntegrationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports